export default "__VITE_ASSET__BB$i4pij__"